import { loanExceptionsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

import { LOAN_EXCEPTIONS_ACTION_TYPE } from '../types';

export const getLoanExceptionsForLoanAction = catchAsyncActionError(
  ({ loanId, signal } = {}) =>
    async dispatch => {
      const { data } = await loanExceptionsApi.getForLoan({ loanId, signal });

      return dispatch({
        type: LOAN_EXCEPTIONS_ACTION_TYPE.GET_FOR_LOAN,
        payload: data,
        meta: { loanId },
      });
    },
);

export const createLoanExceptionAction = catchAsyncActionError(
  ({ payload, signal } = {}) =>
    async dispatch => {
      const { data } = await loanExceptionsApi.create({ payload, signal });

      return dispatch({
        type: LOAN_EXCEPTIONS_ACTION_TYPE.CREATE,
        payload: data,
      });
    },
);

export const updateLoanExceptionAction = catchAsyncActionError(
  ({ id, payload, signal } = {}) =>
    async dispatch => {
      const { data } = await loanExceptionsApi.update({ id, payload, signal });

      return dispatch({
        type: LOAN_EXCEPTIONS_ACTION_TYPE.UPDATE,
        payload: data,
      });
    },
);

export const decideLoanExceptionAction = catchAsyncActionError(
  ({ id, payload, signal } = {}) =>
    async dispatch => {
      const { data } = await loanExceptionsApi.decide({ id, payload, signal });

      return dispatch({
        type: LOAN_EXCEPTIONS_ACTION_TYPE.DECIDE,
        payload: data,
      });
    },
);

export const withdrawLoanExceptionAction = catchAsyncActionError(
  ({ id, payload, signal } = {}) =>
    async dispatch => {
      const { data } = await loanExceptionsApi.withdraw({ id, payload, signal });

      return dispatch({
        type: LOAN_EXCEPTIONS_ACTION_TYPE.WITHDRAW,
        payload: data,
      });
    },
);

export const clearLoanExceptionsAction = () => ({
  type: LOAN_EXCEPTIONS_ACTION_TYPE.CLEAR,
});
